import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageTitle from '../PageTitle';
import CarouselComponent from '../Carousel';
import ProfileItem from '../ProfileItem';
import BoardSetup from '../BoardSetup';
import ButtonItem from '../ButtonItem';
import { buttonType } from '../utils/constants';
import EspWebInstallButton from '../EspWebInstallButton';
import ModalItem from '../ModalItem';
import { StoreContext } from '../lib/Store';

const Binary = ({ image, name, occupation, socials }) => {
  const { state } = useContext(StoreContext);
  const { group, id, board } = useParams();
  const [binary, setBinary] = useState({});

  useEffect(() => {
    try {
      const result = state.data.binaries.filter(
        (_binary, i) => _binary.id === id
      );
      if (result.length > 0) {
        setBinary(result[0]);
      }
    } catch (error) {}
  }, [id, state]);

  if (Object.keys(binary).length === 0) {
    return <p>Data Not Found</p>;
  }

  return (
    <>
      <PageTitle
        originPath='/'
        originPathName='Home'
        sensorName={binary.name}
      />
      {/* <!-- End Page Title --> */}

      <section className='section'>
        <div className='row'>
          {/* Binary Images Caurosel */}
          <div className='col-lg-7'>
            <div className='d-flex-column adjust-content-between'>
              {/* <!-- Fade Carousel --> */}
              <div className='d-flex justify-content-center'>
                <CarouselComponent
                  carousel={[...binary.caurosel, binary.icon[group][board]]}
                  sensorName={binary.name}
                />
              </div>
              <div className='text-muted text-center mb-3'>
                The carousel shows uploads from users and provides visual
                instruction
              </div>
            </div>
            <div className='card shadow-none'>
              <div className='card-body pb-0'>
                <div className='news'>
                  {binary.setup && (
                    <div className='post-item clearfix pb-2'>
                      <h4 className='display-6 border-bottom p-2'>
                        Setup Description
                      </h4>

                      <p
                        className='text-justify'
                        style={{ fontSize: '0.95rem' }}
                      >
                        {binary.setup}
                      </p>
                      <br />
                    </div>
                  )}

                  {binary.description && (
                    <div className='post-item clearfix pb-2'>
                      <h4 className='display-6 border-bottom p-2'>
                        Sensor Description
                      </h4>

                      <p
                        className='text-justify'
                        style={{ fontSize: '0.95rem' }}
                      >
                        {binary.description}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className='col-lg-5'>
            <div className='row'>
              {/* <!-- Right side columns --> */}
              <div className='col-lg-12 profile'>
                {/* <!-- Profile --> */}
                <ProfileItem
                  image={image}
                  name={name}
                  occupation={occupation}
                  socials={socials}
                  classNames='card d-none d-sm-block'
                />
                {/* <!-- End Profile --> */}
              </div>

              <div className='col-lg-12'>
                <div className='card shadow-none'>
                  <span className='text-muted text-center'>
                    All components you need:
                  </span>
                  {/* Sensor Combination */}
                  <BoardSetup
                    {...binary.combination[board]}
                    sensorName={binary.name}
                  />

                  <div className='card-body pt-2'>
                    <div className='d-flex-column'>
                      <div
                        className='d-flex justify-content-between align-items-center mb-2' //'btn-group bg-info w-100 mb-2'
                        //  role='group'
                        //  aria-label='Basic mixed styles example'
                      >
                        {binary.manifest[group].endsWith('.json') ? (
                          <EspWebInstallButton
                            label='Install'
                            PathToManifest={'/' + binary.manifest[group]}
                            classNames='btn-md'
                          />
                        ) : (
                          <ButtonItem
                            type={buttonType.LINK}
                            iconClass='bi bi-telephone'
                            label='Contact us'
                            url={binary.manifest[group]}
                            classStyles={['btn-md btn-info text-white']}
                          />
                        )}

                        <div>
                          <ModalItem
                            buttonLabel='Order Hardware Parts'
                            modalTitle='Place Order'
                            modalBody={<p>Place Order coming soon..!</p>}
                            className='btn-secondary btn-sm'
                            iconClass='bi bi-cart3'
                          />
                        </div>
                      </div>
                      <div
                        className='btn-group bg-info w-100 mb-2'
                        role='group'
                        aria-label='Basic mixed styles example'
                      >
                        <ModalItem
                          buttonLabel='Request Software Modification'
                          modalTitle='Binary Modfication Request'
                          modalBody={<p>Modification request coming soon..!</p>}
                          className='btn-warning btn-sm'
                          iconClass='bi bi-code-slash'
                        />
                      </div>
                      <div
                        className='btn-group bg-info w-100 mb-2'
                        role='group'
                        aria-label='Basic mixed styles example'
                      >
                        <ButtonItem
                          type={buttonType.LINK}
                          iconClass='bi bi-github'
                          label='Sensor GitHub Repository'
                          url={binary.repository[board]}
                          classStyles={['btn-dark']}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Binary Description */}
          {/* <div className='col-lg-12'>
            <div className='card'>
              <div className='card-body pb-0'>
                <div className='news'>
                  {binary.setup && (
                    <div className='post-item clearfix pb-2'>
                      <h4 className='display-6 border-bottom p-2'>
                        Setup Description
                      </h4>

                      <p
                        className='text-justify'
                        style={{ fontSize: '0.95rem' }}
                      >
                        {binary.setup}
                      </p>
                      <br />
                    </div>
                  )}

                  {binary.description && (
                    <div className='post-item clearfix pb-2'>
                      <h4 className='display-6 border-bottom p-2'>
                        Sensor Description
                      </h4>

                      <p
                        className='text-justify'
                        style={{ fontSize: '0.95rem' }}
                      >
                        {binary.description}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default Binary;
